export default {
    workload: {
        add_title: 'Agregar Carga de Trabajo',
        edit_title: 'Editar Carga de Trabajo',
        finish_title: 'Finalizar Carga de Trabajo',
    },

    app_search: {
        search_placeholder: 'Buscar Tickets o Tareas',
        search_placeholder_task: 'Buscar Tareas',
        search_placeholder_ticket: 'Buscar Tickets',
        search_info: 'Ingrese el número o título de un ticket o tarea',
        search_info_task: 'Ingrese el número o título de una tarea',
        search_info_ticket: 'Ingrese el número o título de un ticket',
    },
}
